import { useCallback, Children } from 'react';
import classNames from 'classnames';
import { components } from 'react-select';
import { makeStyles } from '@material-ui/core';
import VirtualizedList from '../../virtualizedList';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    maxHeight: '216px !important',
    padding: `0 !important`,
  },
  viewport: {
    padding: `${spacing(0, 4)} !important`,
    maxHeight: 216,
  },
  verticalScroll: {
    right: 5,
  },
}));

const MenuList = props => {
  const classes = useStyles();

  const { children, selectProps } = props;

  const childrenArray = Children.toArray(children);

  const getMenuItemSize = useCallback(() => 40, []);

  return (
    <components.MenuList
      {...props}
      className={classNames(classes.root, selectProps?.menuListClass)}
    >
      <VirtualizedList
        viewportClass={classNames(classes.viewport, selectProps?.menuListClass)}
        verticalScrollClass={classes.verticalScroll}
        count={childrenArray?.length ?? 0}
        gap={selectProps?.isCategorized ? 0 : 4}
        estimateSize={getMenuItemSize}
        items={childrenArray}
        itemsCount={childrenArray.length}
        isDynamicSize={!!selectProps?.isCategorized}
      />
    </components.MenuList>
  );
};

export default MenuList;
